import * as moment from 'moment';
import axios from 'axios';

import config from '../utils/config';
import * as CommunicationActions from '../actions/communication';

import {
  authIdInputValue$,
  emailInputValue$,
} from '../selectors/findUser';
import { currentProductName$ } from '../selectors/product';
import {
  dateStart$,
  dateEnd$,
} from '../selectors/datepickers';

import ReduxAction from '../interfaces/ReduxAction';

const URL = config().communication;

axios.defaults.xsrfHeaderName = 'X-CSRFTOKEN';
axios.defaults.xsrfCookieName = 'csrftoken';

export const communication = (): ReduxAction => {
  return (dispatch, getState): void => {
    dispatch(CommunicationActions.fetchCommunicationPending());
    const params = new URLSearchParams();

    function paramsAppender (paramName, paramVal) {
      if (paramVal) {
        return params.append(paramName, paramVal);
      } else {
        return null;
      }
    }

    paramsAppender('customer_id', authIdInputValue$(getState()));
    paramsAppender('customer_email', emailInputValue$(getState()));
    paramsAppender('product', currentProductName$(getState()));
    paramsAppender('date_from', moment(dateStart$(getState())).format('YYYY-MM-DD'));
    paramsAppender('date_to', moment(dateEnd$(getState())).format('YYYY-MM-DD'));

    axios({
      method: 'post',
      url: URL,
      data: params,
    })
      .then(response => {
        dispatch(CommunicationActions.fetchCommunicationSuccess(response.data));
      })
      .catch(error => {
        // @ts-ignore
        dispatch(CommunicationActions.fetchCommunicationFail(error));
      });
  };
};
